import React, { useCallback } from "react";
import {
  Button,
  Group,
  Text,
  Modal,
  Grid,
  Avatar,
  useMantineTheme,
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faExclamation,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

export default function Message(props) {
  const theme = useMantineTheme();

  const MakeSymbol = useCallback((color, icon) => {
    return (
      <Avatar color={color} radius="xl" size="lg">
        <FontAwesomeIcon icon={icon} size="2x" />
      </Avatar>
    );
  }, []);

  const MakeIcon = useCallback((value) => {
    let item = <></>;

    if (value === "error") {
      item = MakeSymbol("red", faXmark);
    } else if (value === "warning") {
      item = MakeSymbol("orange", faExclamation);
    } else if (value === "info") {
      item = MakeSymbol("blue", faExclamation);
    } else if (value === "success") {
      item = MakeSymbol("green", faCheck);
    } else {
      item = MakeSymbol("yellow", faExclamation);
    }

    return item;
  }, []);

  return (
    <Modal
      opened={props.onopen}
      onClose={props.onclose}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      centered
      overlayOpacity={0.55}
      overlayColor="#000"
      trapFocus={false}
    >
      <Grid align="center">
        <Grid.Col span={2} style={{ minHeight: 36 }}>
          {MakeIcon(props.type)}
        </Grid.Col>
        <Grid.Col span={10} style={{ minHeight: 36 }}>
          <Text size="sm">{props.message}</Text>
        </Grid.Col>
      </Grid>

      <Group position="right">
        <Button
          mt="sm"
          onClick={props.onclose}
          style={{
            backgroundColor: theme.colors["deep-blue"][0],
            borderRadius: 4,

            "&:hover": {
              backgroundColor: theme.colors["deep-blue"][1],
            },
          }}
        >
          Close
        </Button>
      </Group>
    </Modal>
  );
}
